<template>
    <div class="wrap">
        <div class="loader">
            <div class="rect1"></div>
            <div class="rect2"></div>
            <div class="rect3"></div>
            <div class="rect4"></div>
            <div class="rect5"></div>
        </div>
    </div>
</template>

<script>
    import Velocity from 'velocity-animate'
    export default {
        props: ['loaderActive'],
        watch: {
            loaderActive: {
                handler () {
                    if (this.loaderActive === false) {
                      Velocity(this.$el, 'fadeOut', { duration: 300 })
                    }

                    if (this.loaderActive === true) {
                      Velocity(this.$el, 'fadeIn', { duration: 300 })
                    }
                },
                deep: true
            }
        }
    }
</script>

<style rel="stylesheet/scss" type="text/css" lang="scss" scoped>
    .wrap {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #ffffff;
        top: 0;
        z-index: 10;
    }

    .loader {
        position: relative;
        margin: 100px auto;
        width: 50px;
        height: 40px;
        text-align: center;
        font-size: 10px;

        > div {
            background: #617ba8;
            height: 100%;
            width: 6px;
            display: inline-block;
            -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
            animation: sk-stretchdelay 1.2s infinite ease-in-out;
        }

        .rect2 {
            -webkit-animation-delay: -1.1s;
            animation-delay: -1.1s;
        }

        .rect3 {
            -webkit-animation-delay: -1.0s;
            animation-delay: -1.0s;
        }

        .rect4 {
            -webkit-animation-delay: -0.9s;
            animation-delay: -0.9s;
        }

        .rect5 {
            -webkit-animation-delay: -0.8s;
            animation-delay: -0.8s;
        }
    }

    @-webkit-keyframes sk-stretchdelay {
        0%, 40%, 100% { -webkit-transform: scaleY(0.4) }
        20% { -webkit-transform: scaleY(1.0) }
    }

    @keyframes sk-stretchdelay {
        0%, 40%, 100% { transform: scaleY(0.4); -webkit-transform: scaleY(0.4);
        }  20% { transform: scaleY(1.0); -webkit-transform: scaleY(1.0); }
    }
</style>


// WEBPACK FOOTER //
// loader.vue?d0b4f32a